import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";

export default function ModalInformacionParaPago({cita, open, setOpen, onClickGoPayment, setPaymentStatus, configuration, v1=true}){
    const handleClose = () => setOpen(false)
    const [text, setText] = useState(configuration?.paymentText ?? null)
    const [check, setCheck] = useState(true)
    useEffect(() => {
        if(open){
            setTimeout(() => {
                setPaymentStatus('DECLINED')
            }, [900000])
        }
    }, [open])
    useEffect(() => {
        if(check && cita?.costo && text){
            const str = text;
            const newStr = str.replace("#importe-copago", `<strong>${cita?.costo ?? 'no disponible'}</strong>`  );
            const newStr2 = newStr.replace("#moneda-copago", `<strong>${cita?.currency}</strong>`);
            setText(newStr2)
            setCheck(false)
        }        
    }, [text, cita])

    return (
        <Modal show={open} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Body className="position-relative overflow-hidden">
                <div dangerouslySetInnerHTML={{__html: text}} />
                {/* <label>
                    {text}
                    Sr (a). Usuario: Va a ser redirigido al portal de pagos para completar con el pago de la cita, el cual 
                    corresponde al valor de: <strong>{cita?.costo ?? 'no disponible'} {cita?.currency}</strong>. 
                    Recuerde que tiene 15 minutos para realizar el pago, de lo contrario, su cita no será agendada y
                    deberá repetir el proceso de agendamiento. Si usted es usuario extranjero la plataforma de pago le 
                    solicitará el deducible en USD.
                </label>                 */}

                <div className="text-right">
                    {v1 ? <Button variant="light" onClick={onClickGoPayment}>Aceptar</Button> :
                    <button onClick={onClickGoPayment}>Aceptar</button>}
                </div>
            </Modal.Body>
        </Modal>
    )
}